<template>
  <div>
    <!-- Carwash Store -->
  </div>
</template>

<script>
export default {
  name: 'CarwashStore',
  data () { return { 
      pusherChannel: undefined,
      pusher: undefined,
      carwash: {},
    } 
  },
  async created () {
  },
  mounted() {
    Pusher.logToConsole = true;
    this.pusher = new Pusher('7b12b612bdf63d1cdb05', { authEndpoint: `https://fandango-wombat-7897.twil.io/carwash?m=pusherAuth&k=${this.$_auid}` });
    this.pusherChannel = this.pusher.subscribe('private-carwash-events');
    
    this.pusherChannel.bind('client-state-update', function(data) {
      this.$set(this, 'carwash', data)
    });

    this.pusherChannel.bind('client-blink-bay', function(data) {
      consle.log(`Blink Bay ${JSON.stringify(data)}`)
    });

    // this.pusherChannel.trigger('client-update-state', {});
  },
  methods:{
    turnOnBay(bay=1){
      this.pusherChannel.trigger('client-toggle-bay', {bay:bay});
    },
    blink(bay=1){
      this.pusherChannel.trigger('client-blink-bay', {bay:bay});
    },
  },
}
</script>

<style>
  
</style>
